<template>
  <div class="plugin-wrapper" v-if="config && Array.isArray(config.nodes) && config.nodes.length">
    <div :class="['plugin-image_on_text_swiper', 'layout', 'swiper' + _uid]">
      <swiper class="swiper-x-container" :ref="'iotSwiper' + _uid" :options="swiperOpts">
        <swiper-slide class="swiper-x-item" v-for="(item, index) in config.nodes" :key="index">
          <div class="carousel__item">
            <SimpleItem :config="item" />
          </div>
        </swiper-slide>
      </swiper>
      <SwiperNavigator v-if="enableSwiperNavigator" :xSwiper="iotSwiper" :total="config.nodes.length" />
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import SimpleItem from '@/components/SimpleItem';
import SwiperNavigator from '@/components/SwiperNavigator';
import utils from '@/utils/index';

export default {
  name: "ImageOnTextSwiper",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  components: { swiper, swiperSlide, SimpleItem, SwiperNavigator },
  data() {
    return {
      iotSwiper: {},
      swiperOpts: {
        loop: true,
        loopedSlides: this.config.nodes.length + 2,
        speed: 1000,
        slidesPerView: 2,
        breakpoints: {
          768: {
            slidesPerView: 1.25,
            spaceBetween: 0
          },
          1024: {
            slidesPerView: 1.5,
            centeredSlides: true,
            centeredSlidesBounds: true,
            spaceBetween: 0
          }
        },
        navigation: {
          prevEl: `.swiper${this._uid} .carousel__btn--prev`,
          nextEl: `.swiper${this._uid} .carousel__btn--next`
        }
      },
      enableSwiperNavigator: true
    };
  },
  created() {
    // 函数防抖处理
    this.doResize = utils.throttle(this.doResize, 200);
  },
  mounted() {
    this.iotSwiper = this.$refs?.[`iotSwiper` + this._uid]?.swiper;
    this.initResize();
  },
  methods: {
    initResize() {
      this.doResize();
      window.addEventListener('resize', this.doResize, false);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", this.doResize, false);
      });
    },
    doResize() {
      // let showSize = this?.iotSwiper?.slidesPerViewDynamic();
      // if (showSize < this.config.nodes.length) {
      //   this.enableSwiperNavigator = true;
      // } else if (this.config.nodes.length > 1 && window.innerWidth < 1024) {
      //   this.enableSwiperNavigator = true;
      // } else {
      //   this.enableSwiperNavigator = false;
      // }
      this.enableSwiperNavigator = window.innerWidth < 1024;
    }
  }
}
</script>

<style lang="scss" scoped>
  .carousel__item { padding: 0 .625rem; text-align: center; }
  @media screen and (min-width: 48em) {
    .carousel__item { padding: 0 .75rem; }
  }
  @media screen and (min-width: 48em) {
    .carousel__item { padding: 0 .5rem; }
  }
</style>